import { useQuery } from "@tanstack/react-query";

import {
  getOverviewActivityService,
  getOverviewExportService,
  getOverviewStatsService,
  getRequiresAttentionService,
} from "@/services/overview.service";
import {
  AttentionParams,
  AttentionResponse,
  OverviewActivityParams,
  OverviewActivityResponse,
  OverviewExportResponse,
  OverviewRangeParams,
  OverviewStats,
} from "@/types/overview.types";

export const overviewQueryKeys = {
  all: () => ["overview"] as const,
  stats: (params: OverviewRangeParams) => [...overviewQueryKeys.all(), "stats", params] as const,
  attention: (params: AttentionParams) => [...overviewQueryKeys.all(), "attention", params] as const,
  activity: (params: OverviewActivityParams) => [...overviewQueryKeys.all(), "activity", params] as const,
  export: (params: OverviewRangeParams) => [...overviewQueryKeys.all(), "export", params] as const,
};

export const useGetOverviewStats = (params: OverviewRangeParams = {}) =>
  useQuery<OverviewStats, Error>({
    queryKey: overviewQueryKeys.stats(params),
    queryFn: () => getOverviewStatsService(params),
  });

export const useGetRequiresAttention = (params: AttentionParams = {}) =>
  useQuery<AttentionResponse, Error>({
    queryKey: overviewQueryKeys.attention(params),
    queryFn: () => getRequiresAttentionService(params),
  });

export const useGetOverviewActivity = (params: OverviewActivityParams = {}) =>
  useQuery<OverviewActivityResponse, Error>({
    queryKey: overviewQueryKeys.activity(params),
    queryFn: () => getOverviewActivityService(params),
  });

/** Disabled by default — the export is fetched on demand when the button is
 *  clicked, not kept warm alongside the page. */
export const useGetOverviewExport = (params: OverviewRangeParams = {}, { enabled = false } = {}) =>
  useQuery<OverviewExportResponse, Error>({
    queryKey: overviewQueryKeys.export(params),
    queryFn: () => getOverviewExportService(params),
    enabled,
    gcTime: 0,
  });
